import { useDisclosure } from '@mantine/hooks';
import { Modal, Button, NumberInput, Stack, Loader, Group } from '@mantine/core';
import { PROPOSALACTIONS } from '../../reducers/proposalReducer';
import { Proposal } from '@/interfaces/types';
import { useTranslation } from 'react-i18next';
import { IconPlus, IconRotate2 } from '@tabler/icons-react';
import { GenerationService } from '@/services/generationService';
import { useAuth0 } from '@auth0/auth0-react';
import { useProposal } from '../../context/ProposalContext';
import { useGeneration } from '@/hooks/useGeneration';

export function GenerateExperiences() {
  const [opened, { open, close }] = useDisclosure(false);
  const { t } = useTranslation();
  const { getAccessTokenSilently } = useAuth0();
  const { proposal, dispatchProposal, userFeedback, dispatchUserFeedback, dispatchOtherData } =
    useProposal();
  const { loadingExperiences } = userFeedback;

  const { withService, cancelField } = useGeneration({
    dispatchProposal,
    dispatchUserFeedback,
    dispatchOtherData,
  });

  const handleGenerateExperiences = () => {
    const config = {
      input: proposal.input,
      documentLanguage: proposal.language,
      constraints: {
        nExperiences: proposal.constraints?.nExperiences || 0,
      },
      proposal,
    };

    withService(async (svc) => {
      await svc.generateExperiences(config, {
        dispatchProposal,
        dispatchUserFeedback,
        dispatchOtherData,
      });
    });
    close();
  };

  const handleCancel = () => {
    cancelField('experiences');
  };

  return (
    <>
      <Modal opened={opened} onClose={close} title={t('generateFurtherExperiences')} size="xs">
        <Stack>
          <NumberInput
            maw={200}
            label={t('numberOfExperiences')}
            value={proposal.constraints?.nExperiences || 0}
            onChange={(value) => {
              dispatchProposal({
                type: PROPOSALACTIONS.SET_CONSTRAINTS,
                field: 'nExperiences',
                value: value,
              });
            }}
            min={0}
            // description={t('numberOfExperiencesDescription')}
          />
          <Group justify="space-around" mt="md">
            <Button variant="default" onClick={close} w={120}>
              {t('cancel')}
            </Button>
            <Button w={120} color="cyan" variant="light" onClick={handleGenerateExperiences}>
              {t('generate')}
            </Button>
          </Group>
        </Stack>
      </Modal>

      <Button
        color={loadingExperiences ? 'orange' : 'cyan'}
        variant="light"
        leftSection={
          loadingExperiences ? <Loader size="xs" color="cyan" /> : <IconPlus size={18} />
        }
        style={{ marginRight: '0.5rem' }}
        onClick={() => {
          if (loadingExperiences) {
            handleCancel();
          } else {
            open();
          }
        }}
      >
        {loadingExperiences ? t('cancel') : t('generateExperiences')}
      </Button>
    </>
  );
}
